import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'ticket-quota-tickets-info',
	templateUrl: "./ticket-quota-tickets-info.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./ticket-quota-tickets-info.scss")]
})

export class TicketQuotaTicketsInfo {
	@Input() displayTicketsPerTicketQuota = [];
}



// WEBPACK FOOTER //
// ./src/app/components/box-office/ticket-quota-tickets-info/ticket-quota-tickets-info.component.ts